if (!document.getElementById("employer-profile-detail")) return;

// Hide unused buttons if they exist
const confirmUpdate = document.querySelector('.custom-message-modal-btn.confirm');
const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');

if (confirmUpdate) confirmUpdate.style.display = 'none';
if (confirmBtnCancel) confirmBtnCancel.style.display = 'none';

// Setup modal
const modal = document.querySelector('.custom-message-modal-overlay');
const modalTitle = document.querySelector('.custom-message-modal-title');
const modalBodyText = document.querySelector('.custom-message-modal-body');
const modalFooter = document.querySelector('.custom-message-modal-footer');
const modalTriggerBtn = document.querySelector('.open-modal-btn');

// Remove "OK" button if it was previously added
if (modalFooter) modalFooter.innerHTML = '';

// Click outside to close modal (optional)
// if (modal) {
//     modal.addEventListener('click', function(e) {
//         if (e.target.classList.contains('custom-message-modal-overlay')) {
            // modal.classList.remove('d-flex');
//         }
//     });
// }

// Function to show modal message without OK button
function employerProfileDetailModal(message, title='Attention required', autoClose = true) {
    if (modalTitle) modalTitle.innerHTML = title;
    if (modalBodyText) modalBodyText.innerHTML = '';
    if (modalBodyText) modalBodyText.innerHTML = message;

    const modalElement = document.querySelector('.custom-message-modal-overlay');
    if( modalElement ) modalElement.classList.add('processing');
    const modalCross = document.querySelector('.custom-message-modal-close');
    if( modalCross ) modalCross.style.display = 'none';

    // Show modal
    if (modalTriggerBtn) modalTriggerBtn.click();
}

const employerUpload = document.querySelector(".form-employer-logo");
const employerLogo = document.querySelector("#employer-logo");
if(employerLogo) {
    employerLogo.addEventListener("click", function(event) {
        // event.preventDefault();
    });
}
if(employerUpload) {
    employerUpload.addEventListener("click", function(event) {
        document.getElementById("employer-logo").click();
    });
}


const fileInput = document.getElementById("employer-logo");
const logoField = document.getElementById("form-employer-logo");
if (fileInput && logoField) {
    fileInput.addEventListener("change", function () {
        const logoFile = fileInput.files[0];
        if (logoFile && logoFile.name) {
            logoField.dataset.title = logoFile.name;
        }
        if (  logoFile && logoFile.size > 5 * 1024 * 1024 ) {
            document.querySelector('.form-employer-logo small').style.color = 'red';
        } else {
            document.querySelector('.form-employer-logo small').style.color = '#1a3a6d';
        }
    });
}

// Brand Logo
const brandInputs = document.querySelectorAll('input[name="brand_logo[]"]');

brandInputs.forEach(input => {
    if (input.files.length > 0) {
        const file = input.files[0];

        if (file.size > 5 * 1024 * 1024) {
            errors.push({
                message: 'Each brand logo must be under 5MB.',
                scrollDiv: '.form-element-brands-profile',
                attrId: ''
            });
        }
    }
});

// Form submission handler
const employerProfileDetail = document.getElementById("employer-profile-detail");
employerProfileDetail.addEventListener("submit", function(event) {
    event.preventDefault();

    const errors = [];

    const employerName = document.getElementById("employer-name").value.trim();
    const employerType = document.getElementById("employer-type").value.trim();
    const employerLocation = document.getElementById("employer-location").value.trim();
    const suburb = document.getElementById("suburb").value.trim();
    const postcode = document.getElementById("postcode").value.trim();
    const contactName = document.getElementById("contact-name").value.trim();
    const contactNumber = document.getElementById("contactNumber").value.trim();
    const countryCode = document.getElementById("country-code")?.value.trim() || '';

    const logoFile = '';
    const logoUpload = document.getElementById("employer-logo");
    if( logoUpload ) {
        const logoFile = logoUpload.files[0];
        if  (logoFile ) {
            if ( logoFile.size > 5 * 1024 * 1024 ) {
                errors.push({
                    message: 'File size exceeds 5MB. Please upload a smaller file.',
                    scrollDiv: '#employer-name',
                    attrId: '#'
                });
                document.querySelector('.form-employer-logo small').style.color = 'red';
            }
        }
    }

    if (employerName === '') {
        errors.push({ message: 'Employer name is required', scrollDiv: '.pages-employer-profile_detail', attrId: 'employer-name' });
    } else {
        const nameRegex = /^[a-zA-Z\s&._-]{2,50}$/;
        if (!nameRegex.test(employerName)) {
            errors.push({ message: 'Employer name must be alphabets of 2-50 characters including "&, ., _ and -"', scrollDiv: '.pages-employer-profile_detail', attrId: 'employer-name' });
        }
    }

    if (employerType === '') errors.push({ message: 'Employer type is required', scrollDiv: '#employer-profile-detail', attrId: 'employer-type' });
    if (employerLocation === '') {
        errors.push({ message: 'Location is required', scrollDiv: '#employer-profile-detail', attrId: 'employer-location' });
    } else {
        const nameRegex = /^[a-zA-Z0-9\s,\-.'’]{3,100}$/;
        if (!nameRegex.test(employerLocation)) {
            errors.push({ message: 'Location must be alphanumeric of 3-100 characters may include "spaces, commas, hyphens, dots and apostrophes"', scrollDiv: '#employer-profile-detail', attrId: 'employer-location' });
        }
    }
    if (suburb === '') {
        errors.push({ message: 'Suburb is required', scrollDiv: '#employer-profile-detail', attrId: 'suburb' });
    } else {
        const nameRegex = /^[a-zA-Z0-9\s]{2,50}$/;
        if (!nameRegex.test(suburb)) {
            errors.push({ message: 'Location must include alphanumeric of 2-50 characters', scrollDiv: '#employer-profile-detail', attrId: 'suburb' });
        }
    }
    if (postcode ) {
        if (isNaN(postcode)) {
            errors.push({
                message: 'Enter valid postcode',
                scrollDiv: '#employer-profile-detail',
                attrId: 'postcode'
            });
        } else {
            const numberRegex = /^\d{4,10}$/;
            if (!numberRegex.test(postcode)) {
                errors.push({ message: 'Postcode must include numberic of 4-10 numbers', scrollDiv: '#employer-profile-detail', attrId: 'postcode' });
            }
        }
    }
    if (contactName === '') {
        // errors.push({ message: 'Contact name is required', scrollDiv: '#suburb', attrId: 'contact-name' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,100}$/;
        if (!nameRegex.test(contactName)) {
            errors.push({ message: 'Contact name must include alphabets of 2-100 characters', scrollDiv: '#suburb', attrId: 'contact-name' });
        }
    }
    if( contactNumber ) {
        if (!/^\d{10}$/.test(contactNumber)) errors.push({ message: 'Enter a valid 10-digit phone number', scrollDiv: '#suburb', attrId: 'contactNumber' });
    }

    const errorElements = document.querySelectorAll('.err');
    if(errorElements) errorElements.forEach(el => el.remove());

    if (errors.length > 0) {
        errors.forEach(error => {
            const errID = document.getElementById(error.attrId);
            const errMessage = error.message;
            if (errID) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = errMessage;
                errID.after(p);
            }
        });

        // employerProfileDetailModal('<p>Please fill in all necessary details to proceed.</p>');

        const target = document.querySelector(errors[0].scrollDiv);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    // -- social links -- //
    const socialItems = document.querySelectorAll('.social-profile-item');
	const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-./?%&=]*)?$/i;
    const socialProfiles = [];
    let invalidUrl = false;

    socialItems.forEach(item => {
        const urlInput = item.querySelector('input[type="url"]');

        const label = item.querySelector('label')?.textContent.trim();
        const inputValue = urlInput?.value.trim();

        if (!inputValue || !urlPattern.test(inputValue)) {
            invalidUrl = true; 
            urlInput.focus();
            return;
        }
        
        if (label && inputValue) {
            socialProfiles.push({ [label]: inputValue });
        }
    });
    if( invalidUrl ) {
        employerProfileDetailModal('<p>Valid url is required</p>');
        document.querySelector('.form-element-social-profile').scrollIntoView({ behavior: 'smooth' });
        return;
    }
    // --- social links --- //


    /*// --- Brand logos --- //
    const brandItems = document.querySelectorAll('.brand-item');
    const brandLogos = [];
    brandItems.forEach(item => {
        const fileInput = item.querySelector('input[type="file"]');
        if (!fileInput) return;

        const file = fileInput.files[0];
        if (!file) return;
        brandLogos.push(file);
    });*/

    // console.log( brandLogos );

    const formData = new FormData(employerProfileDetail);
    formData.append('action', 'employer_update_profile_detail');
    formData.append('nonce', ajax_callback_data.ajax_nonce);
    formData.append('social_profile', JSON.stringify(socialProfiles));
    formData.append('country_code', countryCode);
    formData.append('contact_phone', contactNumber);
    formData.append('employer_logo', logoFile);
    // brandLogos.forEach(file => {
    //     formData.append('brand_logo[]', file);
    // });

    employerProfileDetailModal('<p>Applying account update...</p>', 'Please wait', false);

    fetch(ajax_callback_data.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            employerProfileDetailModal(`<p>${data.data.message}</p>` || '<p>Profile updated.</p>', 'Confirmation');
            document.querySelector('.dashboard--profile').scrollIntoView({ behavior: 'smooth' });
            window.location.reload();
        } else {
            employerProfileDetailModal(`<p>${data.data?.message}</p>` || '<p>Something went wrong. Try again.</p>');
        }
    })
    .catch(() => employerProfileDetailModal('<p>Something went wrong. Try again.</p>'));
});